import React from 'react';
import type { Tag } from '../../types';
import { cn } from '../../utils';

const TAG_COLOR_CLASSES: Record<Tag['color'], string> = {
  slate: 'border-slate-500/30 bg-slate-500/15 text-slate-200',
  gray: 'border-gray-500/30 bg-gray-500/15 text-gray-200',
  blue: 'border-blue-500/30 bg-blue-500/15 text-blue-200',
  indigo: 'border-indigo-500/30 bg-indigo-500/15 text-indigo-200',
  violet: 'border-violet-500/30 bg-violet-500/15 text-violet-200',
  purple: 'border-purple-500/30 bg-purple-500/15 text-purple-200',
  pink: 'border-pink-500/30 bg-pink-500/15 text-pink-200',
  red: 'border-red-500/30 bg-red-500/15 text-red-200',
  orange: 'border-orange-500/30 bg-orange-500/15 text-orange-200',
  amber: 'border-amber-500/30 bg-amber-500/15 text-amber-200',
  yellow: 'border-yellow-500/30 bg-yellow-500/15 text-yellow-200',
  emerald: 'border-emerald-500/30 bg-emerald-500/15 text-emerald-200',
  teal: 'border-teal-500/30 bg-teal-500/15 text-teal-200',
  cyan: 'border-cyan-500/30 bg-cyan-500/15 text-cyan-200',
};

export function getTagBadgeClasses(color: Tag['color'] = 'blue') {
  return TAG_COLOR_CLASSES[color] || TAG_COLOR_CLASSES.blue;
}

interface TagBadgeProps {
  tag: Tag;
  className?: string;
}

export function TagBadge({ tag, className }: TagBadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex min-h-[24px] items-center rounded-full border px-2.5 py-0.5 text-[11px] font-medium',
        getTagBadgeClasses(tag.color),
        className,
      )}
      title={tag.name}
    >
      {tag.name}
    </span>
  );
}

export default TagBadge;
